<template>
    <div class="bg-[#F6F6F6]">
        <div class="max-w-screen-xl px-4 py-10 mx-auto lg:py-20">
            <div class="grid grid-cols-12 md:gap-x-12 gap-y-8">
                <div class="flex lg:col-span-4 md:col-span-6 col-span-12 gap-x-4 md:border-r-4 border-[#e4e4e4]">
                    <div class="basis-20">
                        <nuxt-img :width="firstIconWidth" :height="firstIconHeight" format="webp" :src="firstIconSrc"
                            alt="section image" class="" loading="lazy" sizes="" />
                    </div>

                    <div class="basis-full textp md:pr-12" v-html="firstText"></div>
                </div>

                <div class="flex lg:col-span-4 md:col-span-6 col-span-12 gap-x-4 lg:border-r-4 border-[#e4e4e4]">
                    <div class="basis-20">
                        <nuxt-img :width="secondIconWidth" :height="secondIconHeight" format="webp" :src="secondIconSrc"
                            alt="section image" class="" loading="lazy" sizes="" />
                    </div>

                    <div class="basis-full textp md:pr-12" v-html="secondText"></div>
                </div>

                <div class="flex col-span-12 md:col-start-4 lg:col-span-4 md:col-span-6 gap-x-4 lg:col-start-0">
                    <div class="basis-20">
                        <nuxt-img :width="thirdIconWidth" :height="thirdIconHeight" format="webp" :src="thirdIconSrc"
                            alt="section image" class="" loading="lazy" sizes="" />
                    </div>

                    <div class="basis-full textp md:pr-12" v-html="thirdText"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

const props = defineProps({
    firstIconSrc: {
        type: String,
        default: '/assets/images/icon-best-1.png'
    },
    firstIconWidth: {
        type: Number,
        default: 55
    },
    firstIconHeight: {
        type: Number,
        default: 57
    },
    firstText: {
        type: String,
        default: '#1 reviewed coffee on Dripped Cofee for “best low acid coffee” and “best coffee beans”'
    },
    secondIconSrc: {
        type: String,
        default: '/assets/images/icon-best-2.png'
    },
    secondIconWidth: {
        type: Number,
        default: 55
    },
    secondIconHeight: {
        type: Number,
        default: 57
    },
    secondText: {
        type: String,
        default: 'BestQualityCofee.com: “Lifeboost Coffee Review - Healthy Coffee that Tastes Great!”'
    },
    thirdIconSrc: {
        type: String,
        default: '/assets/images/icon-best-3.png'
    },
    thirdIconWidth: {
        type: Number,
        default: 55
    },
    thirdIconHeight: {
        type: Number,
        default: 57
    },
    thirdText: {
        type: String,
        default: '#1 single roaster coffee subscription and #1 low acid coffee on Roasty Coffee'
    }
});

defineBuilderComponent({
    friendlyName: 'Content Grid With Icons',
    inputs: [
        {
            name: 'firstIconSrc',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'svg', 'png'],
            defaultValue: '/assets/images/icon-best-1.png'
        },
        {
            name: 'firstIconWidth',
            type: 'number',
            defaultValue: 55
        },
        {
            name: 'firstIconHeight',
            type: 'number',
            defaultValue: 57
        },
        {
            name: 'firstText',
            type: 'richText',
            defaultValue: '#1 reviewed coffee on Dripped Cofee for “best low acid coffee” and “best coffee beans”'
        },
        {
            name: 'secondIconSrc',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'svg', 'png'],
            defaultValue: '/assets/images/icon-best-2.png'
        },
        {
            name: 'secondIconWidth',
            type: 'number',
            defaultValue: 55
        },
        {
            name: 'secondIconHeight',
            type: 'number',
            defaultValue: 57
        },
        {
            name: 'secondText',
            type: 'richText',
            defaultValue: 'BestQualityCofee.com: “Lifeboost Coffee Review - Healthy Coffee that Tastes Great!”'
        },
        {
            name: 'thirdIconSrc',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'svg', 'png'],
            defaultValue: '/assets/images/icon-best-3.png'
        },
        {
            name: 'thirdIconWidth',
            type: 'number',
            defaultValue: 55
        },
        {
            name: 'thirdIconHeight',
            type: 'number',
            defaultValue: 57
        },
        {
            name: 'thirdText',
            type: 'richText',
            defaultValue: '#1 single roaster coffee subscription and #1 low acid coffee on Roasty Coffee'
        }
    ]
});
</script>
